import React from 'react';
import createFragment from 'react-addons-create-fragment';
import { View } from '@dbk/ui-react-utils';
import { propTypes, defaultProps } from './common';
import PopoverContentContainer from './popover-content-container/popover-content-container';
import getClassNames from './popover-inline.styles';

class PopoverInline extends React.Component {
  static propTypes = propTypes;
  static defaultProps = defaultProps;
  constructor() {
    super();
    this.state = {
      closing: false,
    };
  }
  hide = (e) => {
    e && e.stopPropagation();
    this.setState({
      closing: true,
    });
    this.props.onPopoverClose && this.props.onPopoverClose();
  };

  render() {
    const {
      children,
      content,
      displayBlock,
      id,
      className,
      toolTipAlert,
      title,
      closePopover,
      ...rest
    } = this.props;
    const popover = toolTipAlert?(
    <PopoverContentContainer
    mode="inline"
    onHide={(e)=>{this.hide(e)}}
    closing={this.state.closing}
    id={id}
    title={title}
    toolTipAlert={toolTipAlert}
    onClick={e => e.stopPropagation()}
    {...rest}
    closePopover={closePopover}
  >
    {content}
  </PopoverContentContainer>
):(
      <PopoverContentContainer
        mode="inline"
        onMouseLeave={this.hide}
        onHide={this.hide}
        closing={this.state.closing}
        id={id}
        {...rest}
      >
        {content}
      </PopoverContentContainer>
    );
    const { orientation } = rest;
    const classes = getClassNames(orientation, displayBlock, className);
    return (
      <View id={id} className={classes}>
        {orientation === 'top' || orientation === 'left'
          ? createFragment({ popover, children })
          : createFragment({ children, popover })}
      </View>
    );
  }
}

export default PopoverInline;
